import React, { Component } from "react";
import Theme from "../Theme.js";
import { DirectUpload } from "@rails/activestorage";
import { PulseLoader } from "react-spinners";
import imageCompression from 'browser-image-compression';
export default class DogPictureUpload extends Component {
    state = {
        tempPhoto: null,
        loading: false,
        nameDog: ""
    };
    getHeight(width) {
        if (width > 450) return 140;
        if (width > 400) return 110;
        if (width > 300) return 80;
        return 90;
    }
    getWidth(width) {
        if (width > 450) return 140;
        if (width > 400) return 100;
        if (width > 300) return 60;
        else return 60;
    }
    componentDidUpdate() {
        if (this.props.name !== this.state.nameDog) {
            // console.log("-------------->",this.props.name !== this.state.nameDog);
            this.setState({ nameDog: this.props.name, tempPhoto: null });
        }
    }

    uploadFile = async (event) => {
        const url =
            import.meta.env.VITE_API_ENDPOINT +
            "/rails/active_storage/direct_uploads";
        let file = event.target.files[0];

        if (!file) {
            alert("No file selected");
            return;
        }

        this.setState({ loading: true });

        const originalType = file.type;
        const originalSize = file.size;

        // Handle camera captures that may have empty MIME type
        if (!file.type || file.type === '') {
            console.log('DogPictureUpload - Empty MIME type detected, creating new File with image/jpeg');
            const fileName = file.name || `camera_${Date.now()}.jpg`;
            file = new File([file], fileName, { type: 'image/jpeg' });
        }

        // Compress and convert image (handles HEIC, large files, etc.)
        // Skip compression for unsupported formats (DNG, RAW, TIFF, etc.)
        const compressibleTypes = [
            'image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/gif',
            'image/heic', 'image/heif', 'image/bmp'
        ];
        const compressibleExtensions = ['.jpg', '.jpeg', '.png', '.webp', '.gif', '.heic', '.heif', '.bmp'];
        const fileExt = file.name?.toLowerCase().match(/\.[^.]+$/)?.[0] || '';
        const isCompressible = compressibleTypes.includes(file.type?.toLowerCase()) ||
            compressibleExtensions.includes(fileExt);

        if (isCompressible) {
            const compressionOptions = {
                maxSizeMB: 1,
                maxWidthOrHeight: 1920,
                useWebWorker: true,
                fileType: 'image/jpeg' // Force output to JPEG for compatibility
            };

            console.log('DogPictureUpload - Compressing image:', {
                originalType,
                originalSize,
                fileName: file.name
            });

            try {
                file = await imageCompression(file, compressionOptions);
                console.log('DogPictureUpload - Compression complete:', {
                    newType: file.type,
                    newSize: file.size,
                    compressionRatio: ((1 - file.size / originalSize) * 100).toFixed(1) + '%'
                });
            } catch (compressionError) {
                console.warn('DogPictureUpload - Compression failed, using original:', compressionError);
            }
        } else {
            console.log('DogPictureUpload - Skipping compression for unsupported format:', {
                fileType: file.type,
                fileName: file.name
            });
        }

        // Generate preview from compressed file
        const reader = new FileReader();
        reader.onloadend = () => {
            this.setState({ tempPhoto: reader.result });
        };
        reader.readAsDataURL(file);

        console.log('DogPictureUpload - Starting upload:', {
            fileName: file.name,
            fileType: file.type,
            fileSize: file.size,
            timestamp: new Date().toISOString()
        });

        const upload = new DirectUpload(file, url);
        upload.create((error, blob) => {
            if (error) {
                console.error('DogPictureUpload - Upload error:', error);
                alert("Failed to upload image");
                this.setState({ loading: false });
                return;
            }
            console.log('DogPictureUpload - Upload successful:', { blobId: blob.id });
            this.props.onUpload(blob.signed_id, reader.result);
            this.setState({ loading: false });
        });
    };

    render() {
        const {
            picture,
            name,
            width,
            containerStyle,
            disableForMembers,
            verticalCenter,
            notSelected
        } = this.props;
        const { tempPhoto, loading } = this.state;
        const shrink = width < 725;
        // console.log("Picture--------------", tempPhoto, "--->",);
        if (loading) {
            return (
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: this.getHeight(width),
                        width: this.getWidth(width),
                        marginBottom: 15,
                        border: "3px solid transparent",
                        ...containerStyle
                    }}
                >
                    <PulseLoader
                        style={{ margin: "auto" }}
                        size={10}
                        color={"#fff"}
                        loading={loading}
                    />
                </div>
            );
        } else
            return (
                <div style={containerStyle}>
                    <div style={
                        {
                            width: "100%",
                            display: "block",
                            float: "left",
                            marginBottom: "30px"
                        }
                    }>
                        <input
                            id={name}
                            name={name}
                            type="file"
                            accept="image/*"
                            style={{
                                width: 0.1,
                                height: 0.1,
                                opacity: 0,
                                overflow: "hidden",
                                position: "absolute",
                                zIndex: -1
                            }}
                            onChange={event => {
                                if (disableForMembers && !(this.props.picturePresent === null)) {
                                    alert("Please see an employee to update this image.");
                                } else {
                                    this.uploadFile(event);
                                }
                            }}
                        />
                        <label
                            htmlFor={name}
                            style={{
                                display: shrink ? "block" : "flex",
                                flexDirection: "column",
                                backgroundColor: "white",
                                marginBottom: `${verticalCenter ? "auto" : "15px"}`,
                                marginTop: `${verticalCenter ? "100px" : "100px"}`,
                                marginLeft: shrink ? "auto" : "auto",
                                marginRight: shrink ? "auto" : "auto",
                                border: "3px solid",
                                borderRadius: 10,
                                cursor: "pointer",
                                height: this.getHeight(width),
                                width: this.getWidth(width),
                                minHeight: 140,
                                minWidth: 140,
                                borderColor: notSelected
                                    ? Theme.LIGHT_TEXT_COLOR
                                    : Theme.LINK_FONT_COLOR
                            }}
                        >
                            {picture || tempPhoto ? (
                                <img
                                    alt=""
                                    style={{
                                        borderRadius: 7,
                                        height: this.getHeight(width),
                                        width: this.getWidth(width),
                                        minHeight: 140,
                                        minWidth: 140
                                    }}
                                    src={picture || tempPhoto}
                                />
                            ) : (
                                    <div
                                        style={{
                                            color: Theme.LIGHT_TEXT_COLOR,
                                            fontSize: Theme.getSmallFont(width),
                                            fontFamily: Theme.MAIN_FONT,
                                            margin: "auto"
                                        }}
                                    >
                                        + Picture
                                    </div>
                                )}
                        </label>
                    </div>
                    {this.props.bannedComponent}
                    {this.props.renderStrikes}
                </div>
            );
    }
}
